define.alias("shared/helpers/profile-color-class", "calendar/helpers/profile-color-class");